export const GET_FACTURE_SUCCESS = "GET_FACTURE_SUCCESS";
export const GET_FACTURE_LOAD = "GET_FACTURE_LOAD";
export const GET_FACTURE_FAILED = "GET_FACTURE_FAILD";
